(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2000],{

/***/ 77450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64666);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6514);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58951);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25662);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);



// ====================================================================================
var RepickDialog = function(param) {
    var showRepick = param.showRepick, slot = param.slot, title = param.title, onPick = param.onPick;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().push;
    if (!slot) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: showRepick,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                id: "alert-dialog-title",
                sx: {
                    color: "text.primary"
                },
                children: title !== null && title !== void 0 ? title : "Slot no longer available"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    id: "alert-dialog-description",
                    children: "Unable to book the slot ".concat(slot, ". Please choose a different slot.")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    variant: "contained",
                    onClick: onPick ? onPick : function() {
                        return push("/repick");
                    },
                    autoFocus: true,
                    children: "Pick another slot"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RepickDialog);


/***/ }),

/***/ 47518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5616);



var Container = function(param) {
    var children = param.children, sx = param.sx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            m: 1,
            position: "relative",
            width: {
                xs: "100%",
                lg: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }
        }, sx),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 25901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ QuestionHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(25662);
// EXTERNAL MODULE: ./components/iconify.tsx
var iconify = __webpack_require__(88096);
;// CONCATENATED MODULE: ./components/previous.tsx



function Previous(param) {
    var onClick = param.onClick, hasResults = param.hasResults;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: "Go to Previous Page",
        children: !hasResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* default */.Z, {
                icon: "akar-icons:chevron-left"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: onClick,
                sx: {
                    fontFamily: "ABCDiaTypeRegular",
                    textTransform: "capitalize"
                },
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* default */.Z, {
                    icon: "akar-icons:chevron-left"
                }),
                children: "Go Back To Results"
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/logo.tsx




// @mui

// ----------------------------------------------------------------------
function Logo(_param) {
    var other = (0,_extends/* default */.Z)({}, _param);
    var fill = "#333033";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1
        }
    }, other), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "https://www.thrivelab.com",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 172.67 34.81",
                width: "110px",
                height: "22px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "Layer_2",
                    "data-name": "Layer 2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "Layer_1-2",
                        "data-name": "Layer 1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M10.91,31.14c-1.17,2.49-2.49,3.67-5.41,3.67C1.93,34.81.05,32.5.05,28L0,5.64c1-.09,2.78-.89,4.33-1.08V11h6.35v1.27H4.33v15.9c0,2.68.75,4.33,3,4.33a3.7,3.7,0,0,0,3.24-1.65Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M30.91,30V19.33c0-4.19-2-6.59-5.6-6.59A7.07,7.07,0,0,0,19,16.23V30c0,2.3.14,3.62.94,4.47H13.69c.85-.85,1-2.17,1-4.47V8.23c0-2.31-.24-5.46-1.13-6.3C15.05,1.78,17.12.24,18.91,0V14.86a9.81,9.81,0,0,1,8-4.42c5.5,0,8.28,3.2,8.28,9.22V30c0,2.3.14,3.62,1,4.47H30c.8-.85.95-2.17.95-4.47"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M55.5,11.52l-1.18,2.82h0a3.66,3.66,0,0,0-3.52-2.25,6.8,6.8,0,0,0-6.26,4.13V30c0,2.3.14,3.62.94,4.47H39.22c.85-.85,1-2.17,1-4.47V15.57c0-2.26-.19-3.3-1-4.14a39.72,39.72,0,0,0,4.93-.57v4.47c1.51-3,3.91-4.89,7-4.89a8.8,8.8,0,0,1,4.38,1.08"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M64.94,34.48H58.55c.89-.85,1.08-2.17,1.08-4.47V15.47c0-2.3-.24-3.38-1.13-4.23,1.5-.1,3.62-.24,5.41-.47V30c0,2.3.19,3.62,1,4.47"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M64,4.23a2.63,2.63,0,0,1-5.26,0,2.63,2.63,0,0,1,5.26,0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M90.3,10.86a7,7,0,0,0-2.17,3.67L80.94,34.48h-4L69.69,14.63a7.34,7.34,0,0,0-2.35-3.77h6.21c-.85.94-.09,2.12.47,3.58l6.4,17.68,6.35-17.73c.52-1.46.7-2.78-.24-3.53Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M95,21.31l13.32,0c-.19-6-2.26-9.92-6.26-9.92s-6.73,3.9-7.06,9.88m0,1.31c0,7.15,3.52,11,7.76,11a11.18,11.18,0,0,0,7.85-3.95h0l.89,1.88a15.09,15.09,0,0,1-9.45,3.3c-6.68,0-11.71-4.71-11.71-12.09,0-6.92,4.7-12.28,11.61-12.28s10.31,4.94,10.4,11.71v.42H94.91Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M115.11,1.92c1.51-.14,3.62-1.68,5.41-1.92V30c0,2.3.19,3.62,1,4.47h-6.4c.89-.85,1.08-2.17,1.08-4.47V6.16c0-2.31-.23-3.39-1.13-4.24"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M140.7,30.2V24.83a7.54,7.54,0,0,0-5.5-2.26c-4.1,0-5.74,2.54-5.74,5.08,0,2.73,2.21,5,5.78,5a7.66,7.66,0,0,0,5.46-2.44m.38,4.28-.24-3.3a9.8,9.8,0,0,1-7.71,3.63c-4.57,0-7.86-2.73-7.86-6.92s3.34-7,8.61-7a10,10,0,0,1,6.82,2.64V19.09c0-4.37-1.32-7.52-6-7.52A9.55,9.55,0,0,0,127.86,15h0l-.7-2.3a14.42,14.42,0,0,1,8.23-2.26c7.15,0,9.59,3.86,9.59,9.41V30.57c0,2,.1,3.11.85,3.91Z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: fill,
                                d: "M168.24,22.72c0-6.78-2.82-10-7.19-10a8,8,0,0,0-6.4,4.1V28.12c1.55,2.83,4.28,4.38,6.4,4.38,4.42,0,7.19-3.25,7.19-9.78m4.43,0c0,7.48-3.77,12.09-9.88,12.09a8.5,8.5,0,0,1-8.14-5.27l-.42,4.94h-4.94c.89-.85,1.08-2.17,1.08-4.47V6.16c0-2.31-.19-3.39-1.08-4.23,1.5-.1,3.62-1.69,5.41-1.93l0,15.66a8.52,8.52,0,0,1,8.14-5.22c5.92,0,9.88,4.66,9.88,12.28"
                            })
                        ]
                    })
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/header.tsx



// components


function QuestionHeader(param) {
    var onPrevious = param.onPrevious, hasResults = param.hasResults;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            height: "60px",
            background: "#F7F2E8",
            // flex: 1,
            flexGrow: 1,
            borderRadius: "0 0 16px 16px",
            width: "100%",
            // maxWidth: { xs: "100%", lg: "60%" },
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            mx: "auto",
            maxHeight: "64px",
            mb: 2
        },
        children: [
            onPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(Previous, {
                onClick: onPrevious,
                hasResults: hasResults
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
        ]
    });
};


/***/ }),

/***/ 88096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Iconify; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5616);



// icons

// @mui

function Iconify(_param) {
    var icon = _param.icon, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "icon",
        "sx"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        component: _iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO,
        icon: icon,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sx)
    }, other));
};


/***/ }),

/***/ 61843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ availableSlots; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js + 1 modules
var getUnixTime = __webpack_require__(28401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMinutes/index.js
var addMinutes = __webpack_require__(58545);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(30377);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(25662);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(70722);
// EXTERNAL MODULE: ./utils/services/available-checker.ts
var available_checker = __webpack_require__(88303);
// EXTERNAL MODULE: ./utils/booking.ts
var booking = __webpack_require__(27172);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
;// CONCATENATED MODULE: ./components/services/slots.tsx



var Slots = function(param) {
    var slots = param.slots, caption = param.caption, submitting = param.submitting, handleSelectSlot = param.handleSelectSlot, verifying = param.verifying;
    if (slots.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "caption",
                align: "center",
                color: "primary",
                children: caption
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "grid",
                    width: "100%",
                    rowGap: 0.5,
                    columnGap: 0.5,
                    marginLeft: "auto",
                    boxSizing: "border-box",
                    marginRight: "auto",
                    gridTemplateColumns: {
                        xs: "repeat(3, 1fr)",
                        lg: "repeat(6, 1fr)"
                    }
                },
                children: slots === null || slots === void 0 ? void 0 : slots.map(function(slot, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                        variant: "contained",
                        loading: submitting || verifying,
                        sx: {
                            p: 0.5,
                            m: 0.5,
                            heigh: "4rem",
                            minHeight: {
                                xs: "2.5rem",
                                sm: "auto"
                            },
                            background: "#fff",
                            fontFamily: "ABCDiaTypeRegular",
                            border: 1,
                            borderColor: "#725E54",
                            // borderColor: "text.primary",
                            fontSize: "1rem",
                            color: "text.primary",
                            boxShadow: "1px 1px 6px 0 rgb(0 0 0 / 10%)",
                            "&:hover": {
                                backgroundColor: "#98A481",
                                border: "none",
                                color: "#fff"
                            }
                        },
                        onClick: function() {
                            return handleSelectSlot(slot);
                        },
                        color: "primary",
                        children: slot.time
                    }, "idx-".concat(idx));
                })
            })
        ]
    });
};
/* harmony default export */ var services_slots = (Slots);

// EXTERNAL MODULE: ./hooks/useBooking.ts
var useBooking = __webpack_require__(62106);
// EXTERNAL MODULE: ./utils/utmParser.ts
var utmParser = __webpack_require__(38659);
// EXTERNAL MODULE: ./components/RepickDialog.tsx
var RepickDialog = __webpack_require__(77450);
;// CONCATENATED MODULE: ./components/services/availableSlots.tsx















// context




// ======================================================
var shuffle = function(array) {
    for(var i = array.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var ref;
        ref = [
            array[j],
            array[i]
        ], array[i] = ref[0], array[j] = ref[1], ref;
    }
    return array;
};
var removeDuplicates = function(slots) {
    var uniqueIds = new Set();
    var unique = shuffle(slots).filter(function(element) {
        var isDuplicate = uniqueIds.has(element.time);
        uniqueIds.add(element.time);
        if (!isDuplicate) {
            return true;
        }
        return false;
    });
    return unique.sort(function(a, b) {
        return (0,parseISO/* default */.Z)(a.orgTime).getTime() - (0,parseISO/* default */.Z)(b.orgTime).getTime();
    });
};
var AvailableSlots = function(param) {
    var slots = param.slots, isEmpty = param.isEmpty, isLoading = param.isLoading, dpc = param.dpc, timeZone = param.timeZone, info = param.info, freeConsult = param.freeConsult, reschedule = param.reschedule, payToResched = param.payToResched, repick = param.repick, preloaded = param.preloaded, serviceId = param.serviceId, selectedDay = param.selectedDay, _isITH = param.isITH, isITH = _isITH === void 0 ? false : _isITH;
    var ref = (0,router.useRouter)(), push = ref.push, query = ref.query;
    var cookies = (0,useCookies/* default */.Z)();
    var ref1 = (0,react.useState)(false), saving = ref1[0], setSaving = ref1[1];
    var ref2 = (0,react.useState)(false), verifying = ref2[0], setVerifying = ref2[1];
    var ref3 = (0,react.useState)({
        morning: [],
        afternoon: [],
        evening: []
    }), available = ref3[0], setAvailable = ref3[1];
    var ref4 = (0,react.useState)(null), pickAgain = ref4[0], setRepick = ref4[1];
    var ref5 = (0,react.useState)(false), showDialog = ref5[0], setShowDialog = ref5[1];
    var ref6 = (0,react.useState)(), slot = ref6[0], setSlot = ref6[1];
    var context = (0,useBooking/* useBookingContext */.Qo)();
    (0,react.useEffect)(function() {
        var rawData = [];
        if (slots && (slots === null || slots === void 0 ? void 0 : slots.length) > 0) {
            slots.filter(function(x) {
                return x.staffId !== "" && x.date === selectedDay;
            }).forEach(function(item) {
                var _rawData;
                var ref;
                var items = (ref = item.available) === null || ref === void 0 ? void 0 : ref.map(function(time) {
                    return {
                        timeZone: timeZone !== null && timeZone !== void 0 ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone,
                        date: item.date,
                        id: item.id,
                        orgTime: time,
                        time: (0,date_fns_tz.formatInTimeZone)(time, timeZone !== null && timeZone !== void 0 ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone, "p"),
                        staffId: item.staffId,
                        staffEmail: item.staffEmail,
                        hour: Number((0,date_fns_tz.formatInTimeZone)(time, timeZone !== null && timeZone !== void 0 ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone, "HH"))
                    };
                });
                (_rawData = rawData).push.apply(_rawData, (0,_to_consumable_array/* default */.Z)(items));
            });
        }
        var ref, ref1;
        var minimum = (ref1 = (ref = dpc === null || dpc === void 0 ? void 0 : dpc.Minimum_Booking_Notice_Min) !== null && ref !== void 0 ? ref : info === null || info === void 0 ? void 0 : info.Minimum_Booking_Notice_Min) !== null && ref1 !== void 0 ? ref1 : 0;
        rawData = rawData// .sort((a, b) => a.hour - b.hour)
        .filter(function(t) {
            return (0,getUnixTime/* default */.Z)((0,parseISO/* default */.Z)(t.orgTime)) > (0,getUnixTime/* default */.Z)((0,addMinutes/* default */.Z)((0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), "UTC", "yyyy-MM-dd HH:mm:ssXXX")), minimum));
        });
        var morning = (0,available_checker/* includeSlotsWith */.b)(removeDuplicates(rawData === null || rawData === void 0 ? void 0 : rawData.filter(function(t) {
            return t.hour < 12;
        })) || [], info);
        var afternoon = (0,available_checker/* includeSlotsWith */.b)(removeDuplicates(rawData === null || rawData === void 0 ? void 0 : rawData.filter(function(t) {
            return t.hour >= 12 && t.hour < 18;
        })) || [], info);
        var evening = (0,available_checker/* includeSlotsWith */.b)(removeDuplicates(rawData === null || rawData === void 0 ? void 0 : rawData.filter(function(t) {
            return t.hour >= 18;
        })) || [], info);
        setAvailable({
            morning: morning,
            afternoon: afternoon,
            evening: evening
        });
    }, [
        context.data.services,
        info,
        selectedDay,
        slots,
        timeZone,
        dpc === null || dpc === void 0 ? void 0 : dpc.Minimum_Booking_Notice_Min,
        query.service, 
    ]);
    var bookAppointment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
            var ref, isError, data, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSaving(true);
                        _ctx.next = 3;
                        return (0,useBooking/* bookFreeConsult */.Jt)(payload);
                    case 3:
                        ref = _ctx.sent;
                        isError = ref.isError;
                        data = ref.data;
                        if (!isError) {
                            if (info.required_documents && info.required_documents[0].length >= 1 && freeConsult.cost > 0) {
                                push("/services/required-docs");
                            } else push("/services/success");
                        } else {
                        // console.log({ isError });
                        }
                        setSaving(false);
                        ;
                        return _ctx.abrupt("return", (ref1 = data === null || data === void 0 ? void 0 : data.zoho) !== null && ref1 !== void 0 ? ref1 : "");
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function bookAppointment(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSelectSlot = function(slot) {
        if (isITH) {
            setSlot(slot);
            var now = new Date();
            var originalDate = new Date(slot.orgTime);
            var timeDiff = (originalDate.getTime() - now.getTime()) / (60 * 60 * 1000);
            var isNotValid = timeDiff > 0 && timeDiff < 24;
            if (!isNotValid) handleSelectSlot(slot);
            setShowDialog(isNotValid);
        } else {
            setSlot(slot);
            handleSelectSlot(slot);
        }
    };
    var handleSelectSlot = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(slot) {
            var ref, ref1, parked, ref2, canBook, trackers, startTime, endTime, ref3, cost, _$param, meetingId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (slot) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setShowDialog(false);
                        setVerifying(true);
                        _ctx.next = 7;
                        return (0,booking/* parkSlot */.tq)(slot.staffEmail, slot.staffId, slot.orgTime, "", info.Duration_Min, slot.timeZone);
                    case 7:
                        parked = _ctx.sent;
                        ;
                        _ctx.next = 11;
                        return (0,booking/* stillAvailable */.$e)({
                            staffId: slot.staffId,
                            email: slot.staffEmail,
                            duration: info.Duration_Min,
                            buffer: info.Buffer_Time_Min,
                            start: slot.orgTime,
                            timeZone: timeZone,
                            selectedSlot: slot.orgTime ? {
                                time: slot.orgTime,
                                minBooking: (ref2 = info === null || info === void 0 ? void 0 : info.Minimum_Booking_Notice_Min) !== null && ref2 !== void 0 ? ref2 : 0
                            } : undefined
                        });
                    case 11:
                        canBook = _ctx.sent;
                        if (!(!canBook || !(parked === null || parked === void 0 ? void 0 : (ref = parked.details) === null || ref === void 0 ? void 0 : ref.available))) {
                            _ctx.next = 16;
                            break;
                        }
                        setRepick((0,date_fns_tz.formatInTimeZone)(slot.orgTime, timeZone, "yyyy-MM-dd p"));
                        setVerifying(false);
                        return _ctx.abrupt("return");
                    case 16:
                        setVerifying(false);
                        trackers = (0,utmParser/* getTrackers */.X)(cookies, query);
                        startTime = (0,date_fns_tz.formatInTimeZone)(slot.orgTime, timeZone, "yyyy-MM-dd HH:mm:ssXXX");
                        endTime = (0,addMinutes/* default */.Z)((0,parseISO/* default */.Z)(startTime), info.Duration_Min + (info === null || info === void 0 ? void 0 : info.Buffer_Time_Min));
                        ;
                        cost = (ref3 = Number(info === null || info === void 0 ? void 0 : info.Cost)) !== null && ref3 !== void 0 ? ref3 : 0;
                        _$param = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, freeConsult), {
                            // CRM_Meeting_ID:
                            Start_time: (0,parseISO/* default */.Z)(startTime),
                            patient_time: (0,parseISO/* default */.Z)(startTime),
                            End_time: endTime,
                            channel: info.Channel,
                            service_type: info.service_name,
                            duration: info.Duration_Min,
                            buffer: info.Buffer_Time_Min,
                            cost: info.Cost,
                            Bookings_Staff_ID: dpc ? dpc.staff_id : slot.staffId,
                            googleCalendarId: dpc ? dpc.staff_email : slot.staffEmail,
                            staffId: dpc ? dpc.staff_id : slot.staffId,
                            serviceId: dpc ? dpc.service_id : serviceId !== null && serviceId !== void 0 ? serviceId : "",
                            patient_timezone: timeZone !== null && timeZone !== void 0 ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone,
                            meeting_status: !reschedule ? "upcoming" : "Reschedule"
                        });
                        if (!(reschedule && payToResched)) {
                            _ctx.next = 27;
                            break;
                        }
                        {
                            context.setFreeConsult((0,_object_spread/* default */.Z)({}, trackers, _$param));
                            push("/services/reschedule-payment");
                        }
                        _ctx.next = 43;
                        break;
                    case 27:
                        if (!(!reschedule && !repick && !(freeConsult === null || freeConsult === void 0 ? void 0 : freeConsult.preloaded))) {
                            _ctx.next = 31;
                            break;
                        }
                        {
                            context.setFreeConsult((0,_object_spread/* default */.Z)({}, trackers, _$param));
                            push("/services/contact-info");
                        }
                        _ctx.next = 43;
                        break;
                    case 31:
                        if (!(!reschedule && !repick && (preloaded || (freeConsult === null || freeConsult === void 0 ? void 0 : freeConsult.preloaded)) && cost === 0 && (info === null || info === void 0 ? void 0 : info.Additional_Questions) && (info === null || info === void 0 ? void 0 : (ref1 = info.Additional_Questions) === null || ref1 === void 0 ? void 0 : ref1.length) > 0)) {
                            _ctx.next = 35;
                            break;
                        }
                        {
                            context.setFreeConsult((0,_object_spread/* default */.Z)({}, trackers, _$param));
                            push("/services/additional-questions");
                        }
                        _ctx.next = 43;
                        break;
                    case 35:
                        if (!(!reschedule && !repick && (preloaded || (freeConsult === null || freeConsult === void 0 ? void 0 : freeConsult.preloaded)) && cost === 0)) {
                            _ctx.next = 42;
                            break;
                        }
                        _ctx.next = 38;
                        return bookAppointment(_$param);
                    case 38:
                        meetingId = _ctx.sent;
                        context.setFreeConsult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackers, _$param), {
                            CRM_Meeting_ID: meetingId
                        }));
                        _ctx.next = 43;
                        break;
                    case 42:
                        if (!reschedule && !repick && (preloaded || (freeConsult === null || freeConsult === void 0 ? void 0 : freeConsult.preloaded)) || (info === null || info === void 0 ? void 0 : info.capture_card) === true) {
                            context.setFreeConsult((0,_object_spread/* default */.Z)({}, trackers, _$param));
                            push("/services/payment");
                        } else if (reschedule || repick) {
                            context.setFreeConsult((0,_object_spread/* default */.Z)({}, trackers, _$param));
                            push("/services/reschedule");
                        }
                    case 43:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelectSlot(slot) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RepickDialog/* default */.Z, {
                        showRepick: pickAgain !== null && pickAgain !== "",
                        slot: pickAgain ? pickAgain : "",
                        title: "Slot no longer Available",
                        onPick: function() {
                            return setRepick(null);
                        }
                    }),
                    saving && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            p: 1,
                            my: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            align: "center",
                            fontFamily: "ABCDiaTypeRegular",
                            children: "Please wait..."
                        })
                    }),
                    !saving && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(services_slots, {
                                submitting: false,
                                verifying: verifying,
                                slots: available.morning,
                                caption: "Morning",
                                handleSelectSlot: onSelectSlot
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(services_slots, {
                                submitting: false,
                                verifying: verifying,
                                slots: available.afternoon,
                                caption: "Afternoon",
                                handleSelectSlot: onSelectSlot
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(services_slots, {
                                submitting: false,
                                verifying: verifying,
                                slots: available.evening,
                                caption: "Evening",
                                handleSelectSlot: onSelectSlot
                            })
                        ]
                    }),
                    isEmpty && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        severity: "warning",
                        sx: {
                            mt: 2
                        },
                        children: "Unfortunately there are no slots available for this period. Please click > to see next week’s availability. "
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: showDialog,
                onClose: function() {
                    return setShowDialog(false);
                },
                PaperProps: {
                    sx: {
                        borderRadius: "16px"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        padding: "16px",
                        width: "377px",
                        alignItems: "center",
                        gap: "24px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "8px",
                                marginTop: "24px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    color: "#EB7141",
                                    children: "Warning"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    fontWeight: "bold",
                                    fontSize: "24px",
                                    textAlign: "center",
                                    lineHeight: "30.02px",
                                    children: "The selected appointment time occurs in the next 24 hours"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    fontWeight: "normal",
                                    fontSize: "16px",
                                    textAlign: "center",
                                    lineHeight: "22.4px",
                                    children: "Please acknowledge that it is required you provide your driver’s license and insurance details prior to your appointment time or your appointment will be canceled."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function() {
                                return setShowDialog(false);
                            },
                            variant: "contained",
                            sx: {
                                backgroundColor: "#3D4732",
                                borderRadius: "8px",
                                padding: "10px",
                                width: "100%",
                                textTransform: "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                fontSize: "18px",
                                textAlign: "center",
                                color: "#FCFCFA",
                                children: "Choose Different Time"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                            loading: verifying || false,
                            onClick: function() {
                                return handleSelectSlot(slot);
                            },
                            variant: "text",
                            sx: {
                                textTransform: "none"
                            },
                            children: !verifying && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                fontWeight: "normal",
                                fontSize: "16px",
                                textAlign: "center",
                                color: "#768464",
                                sx: {
                                    textDecoration: "underline"
                                },
                                children: "I acknowledge. Continue to Booking."
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var availableSlots = (AvailableSlots);


/***/ }),

/***/ 55971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);



var InvalidServiceAlert = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            display: "inline-flex",
            p: 2,
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            borderRadius: 1,
            border: "1px solid #FFB0A8",
            background: "#FFD8D5",
            margin: "0 auto !important",
            fontFamily: "ABCDiaTypeRegular",
            maxWidth: {
                xs: "380px",
                lg: "650px"
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        alt: "",
                        src: "/exclamation.png",
                        height: 20,
                        width: 20
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        color: "#A10000",
                        sx: {
                            fontFamily: "ABCDiaTypeBold"
                        },
                        children: "Unknown Service Selected"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "#A10000",
                align: "center",
                fontSize: "16px",
                sx: {
                    lineHeight: "22.4px",
                    letterSpacing: "-0.16px"
                },
                children: [
                    "Unfortunately the Service you have selected is not valid. Please contact support at",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "mailto:support@thrivelab.com",
                        children: "support@thrivelab.com"
                    }),
                    " or call or text us at ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "tel:737-377-1600",
                        children: "737-377-1600"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InvalidServiceAlert);


/***/ }),

/***/ 84202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ schedulePicker; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(30377);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DatePicker/DatePicker.js + 76 modules
var DatePicker = __webpack_require__(91205);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js + 1 modules
var differenceInDays = __webpack_require__(29383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(69119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js
var addYears = __webpack_require__(21593);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMinutes/index.js
var addMinutes = __webpack_require__(58545);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(11640);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(43703);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(70722);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./hooks/useBooking.ts
var useBooking = __webpack_require__(62106);
// EXTERNAL MODULE: ./node_modules/react-multi-date-picker/build/index.js
var build = __webpack_require__(26278);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDateFns/index.js + 45 modules
var AdapterDateFns = __webpack_require__(8817);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(52359);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(25662);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./components/iconify.tsx
var iconify = __webpack_require__(88096);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/eachDayOfInterval/index.js
var eachDayOfInterval = __webpack_require__(9005);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./utils/services/available-checker.ts
var available_checker = __webpack_require__(88303);
;// CONCATENATED MODULE: ./components/services/range.tsx







var Range = function(param) {
    var range = param.range, rawSlots = param.rawSlots, selectedDay = param.selectedDay, handleDateSelected = param.handleDateSelected, timeZone = param.timeZone, maxDate = param.maxDate, minimum = param.minimum, serviceId = param.serviceId;
    var context = (0,useBooking/* useBookingContext */.Qo)();
    var interval = (0,eachDayOfInterval/* default */.Z)({
        start: (0,date_fns_tz.utcToZonedTime)((0,date_fns_tz.formatInTimeZone)(range.start, "UTC", "yyyy-MM-dd HH:mm:ssXXX"), timeZone),
        end: (0,date_fns_tz.utcToZonedTime)((0,date_fns_tz.formatInTimeZone)(range.end, "UTC", "yyyy-MM-dd HH:mm:ssXXX"), timeZone)
    });
    var memoed = (0,react.useMemo)(function() {
        return rawSlots;
    }, [
        rawSlots
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var empty = (0,available_checker/* groupByDayTime */.v)((ref = memoed === null || memoed === void 0 ? void 0 : memoed.filter(function(e) {
            return e.date === selectedDay;
        })) !== null && ref !== void 0 ? ref : [], timeZone, minimum, serviceId, context.data.serviceInfo).isEmpty;
        if (empty) {
            var _loop = function(i) {
                var ref;
                empty = (0,available_checker/* groupByDayTime */.v)((ref = memoed === null || memoed === void 0 ? void 0 : memoed.filter(function(e) {
                    return e.date === (0,format/* default */.Z)(interval[i], "yyyy-MM-dd");
                })) !== null && ref !== void 0 ? ref : [], timeZone, interval[i] > new Date() ? 0 : minimum, serviceId, context.data.serviceInfo).isEmpty;
                if (!empty) {
                    handleDateSelected((0,format/* default */.Z)(interval[i], "yyyy-MM-dd"));
                    return "break";
                }
            };
            for(var i = 0; i <= interval.length - 1; i++){
                var _ret = _loop(i);
                if (_ret === "break") break;
            }
        }
    }, [
        handleDateSelected,
        interval,
        minimum,
        memoed,
        selectedDay,
        timeZone,
        serviceId,
        context.data.serviceInfo, 
    ]);
    var onDateSelected = function(day) {
        handleDateSelected(day);
    };
    var source = [];
    interval.map(function(newDay) {
        var ref;
        var disabled = (0,available_checker/* groupByDayTime */.v)((ref = memoed === null || memoed === void 0 ? void 0 : memoed.filter(function(e) {
            return e.date === (0,format/* default */.Z)(newDay, "yyyy-MM-dd");
        })) !== null && ref !== void 0 ? ref : [], timeZone, minimum, serviceId, context.data.serviceInfo).isEmpty;
        if (maxDate && newDay > (0,parseISO/* default */.Z)(maxDate)) disabled = true;
        source.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: disabled ? "outlined" : "contained",
            sx: {
                p: 1,
                m: 0.5,
                width: {
                    xs: "2.6rem",
                    sm: "3rem"
                },
                height: {
                    xs: "2.6rem",
                    sm: "3rem"
                },
                minWidth: {
                    xs: "2.6rem",
                    sm: "3rem"
                },
                minHeight: {
                    xs: "2.6rem",
                    sm: "3rem"
                },
                fontSize: "12px",
                fontFamily: "ABCDiaTypeRegular",
                border: 1,
                color: (0,format/* default */.Z)(newDay, "yyyy-MM-dd") === selectedDay ? "#fff" : "#725E54",
                background: disabled ? "none" : "#fff",
                backgroundColor: (0,format/* default */.Z)(newDay, "yyyy-MM-dd") === selectedDay ? "#98A481" : "none",
                boxShadow: (0,format/* default */.Z)(newDay, "yyyy-MM-dd") === selectedDay ? "1px 1px 6px 0 rgb(0 0 0 / 5%)" : 0,
                "&:hover": {
                    backgroundColor: "#98A481",
                    border: "none",
                    color: "#fff"
                }
            },
            disabled: disabled,
            onClick: function() {
                return onDateSelected((0,format/* default */.Z)(newDay, "yyyy-MM-dd"));
            },
            children: (0,format/* default */.Z)(newDay, "d eee")
        }, "".concat(newDay.getDate())));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: source
    });
};
/* harmony default export */ var services_range = (Range);

;// CONCATENATED MODULE: ./components/services/rangeSelector.tsx



















// =================================================================
var fetcher = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url, params, controller) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios_default().post(url, params, {
                        signal: controller === null || controller === void 0 ? void 0 : controller.signal
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetcher(url, params, controller) {
        return _ref.apply(this, arguments);
    };
}();
var CalendarTextField = (0,styled/* default */.ZP)(TextField/* default */.Z)({
    "& .MuiOutlinedInput-input": {
        fontFamily: "ABCDiaTypeRegular"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "none"
        },
        "&:hover fieldset": {
            borderColor: "yellow"
        }
    }
});
var isOverSeven = function(start, end) {
    var diff = (0,differenceInDays/* default */.Z)(start, end) > 7;
    return diff;
};
var determinMin = function(info, services) {
    var hasNullMax = services.find(function(s) {
        return (s === null || s === void 0 ? void 0 : s.Minimum_Booking_Notice_Min) === null;
    });
    var ref;
    if (services.length === 0 || hasNullMax && Number(info.Minimum_Booking_Notice_Min) > 0) return (ref = Number(info.Minimum_Booking_Notice_Min)) !== null && ref !== void 0 ? ref : 0;
    else if (hasNullMax) return 0;
    var maxService = services === null || services === void 0 ? void 0 : services.reduce(function(prev, current) {
        var ref, ref1;
        return Number((ref = prev === null || prev === void 0 ? void 0 : prev.Minimum_Booking_Notice_Min) !== null && ref !== void 0 ? ref : 0) > Number((ref1 = current === null || current === void 0 ? void 0 : current.Minimum_Booking_Notice_Min) !== null && ref1 !== void 0 ? ref1 : 0) ? prev : current;
    });
    if (maxService && Number(maxService.Minimum_Booking_Notice_Min) > Number(info.Minimum_Booking_Notice_Min)) return Number(maxService.Minimum_Booking_Notice_Min);
    return Number(info.Minimum_Booking_Notice_Min);
};
var determineMax = function(info, services) {
    var hasNullMax = services.find(function(s) {
        return (s === null || s === void 0 ? void 0 : s.Maximum_Booking_Notice_Min) === null;
    });
    var ref;
    if (services.length === 0 || hasNullMax && Number(info.Maximum_Booking_Notice_Min) > 0) return (ref = Number(info.Maximum_Booking_Notice_Min)) !== null && ref !== void 0 ? ref : 0;
    else if (hasNullMax) return 0;
    var maxService = services === null || services === void 0 ? void 0 : services.reduce(function(prev, current) {
        var ref, ref1;
        return Number((ref = prev === null || prev === void 0 ? void 0 : prev.Maximum_Booking_Notice_Min) !== null && ref !== void 0 ? ref : 0) > Number((ref1 = current === null || current === void 0 ? void 0 : current.Maximum_Booking_Notice_Min) !== null && ref1 !== void 0 ? ref1 : 0) ? prev : current;
    });
    if (maxService && Number(maxService.Maximum_Booking_Notice_Min) > Number(info.Maximum_Booking_Notice_Min)) return Number(maxService.Maximum_Booking_Notice_Min);
    return Number(info.Maximum_Booking_Notice_Min);
};
var RangeSelector = function(param) {
    var onRangeChanged = param.onRangeChanged, dpc = param.dpc, staff = param.staff, timeZone = param.timeZone, useAll = param.useAll, info = param.info, serviceId = param.serviceId, startDate = param.startDate;
    var ref;
    var context = (0,useBooking/* useBookingContext */.Qo)();
    (ref = context.data) === null || ref === void 0 ? void 0 : ref.services;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)([]), rawSlots = ref2[0], setRawSlots = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(null), maxDate = ref4[0], setmaxDate = ref4[1];
    var ref5;
    var ref6 = (0,react.useState)({
        start: (0,date_fns_tz.formatInTimeZone)((ref5 = new Date((0,startOfDay/* default */.Z)(startDate))) !== null && ref5 !== void 0 ? ref5 : new Date(), timeZone, "yyyy-MM-dd 00:00:00XXX"),
        end: (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)(new Date(), 7), timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
        auto: false,
        retries: 0
    }), range = ref6[0], setRange = ref6[1];
    var ref7 = (0,react.useState)(""), selectedDay = ref7[0], setSelectedDay = ref7[1];
    var ref8 = (0,react.useState)(undefined), displayDate = ref8[0], setDisplayDate = ref8[1];
    var fetchSlots = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(controller) {
            var currentDate, max, getStartDate, getEndDate, generatePayload, shuffle, source, data, allResults, filtered;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        currentDate = (0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd 00:00:00XXX"));
                        if (!(useAll && staff.length === 0 || !useAll && dpc === null || range.retries === 5)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (useAll && Number(info === null || info === void 0 ? void 0 : info.Maximum_Booking_Notice_Min) === 0) setmaxDate((0,date_fns_tz.formatInTimeZone)((0,addYears/* default */.Z)(new Date(), 1), timeZone, "yyyy-MM-dd HH:mm:ssXXX"));
                        else {
                            max = determineMax(info, staff);
                            setmaxDate(determineMax(info, staff) > 0 ? (0,date_fns_tz.formatInTimeZone)((0,addMinutes/* default */.Z)(currentDate, max), timeZone, "yyyy-MM-dd HH:mm:ssXXX") : (0,date_fns_tz.formatInTimeZone)((0,addYears/* default */.Z)(currentDate, 1), timeZone, "yyyy-MM-dd HH:mm:ssXXX"));
                        }
                        getStartDate = function(dpc) {
                            var _Minimum_Booking_Notice_Min, ref;
                            var minimum = (ref = (_Minimum_Booking_Notice_Min = dpc.Minimum_Booking_Notice_Min) !== null && _Minimum_Booking_Notice_Min !== void 0 ? _Minimum_Booking_Notice_Min : info.Minimum_Booking_Notice_Min) !== null && ref !== void 0 ? ref : 0;
                            if ((0,isSameDay/* default */.Z)((0,parseISO/* default */.Z)(range.start), (0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd 00:00:ssXXX")))) {
                                var dte = (0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd HH:00:ssXXX"));
                                return (0,date_fns_tz.formatInTimeZone)((0,addMinutes/* default */.Z)(dte, minimum), timeZone, "yyyy-MM-dd HH:00:ssXXX");
                            } else return (0,date_fns_tz.formatInTimeZone)((0,startOfDay/* default */.Z)((0,parseISO/* default */.Z)(range.start)), timeZone, "yyyy-MM-dd 00:00:ssXXX");
                        };
                        getEndDate = function(dpc) {
                            var _Maximum_Booking_Notice_Min, ref;
                            var maximum = (ref = (_Maximum_Booking_Notice_Min = dpc.Maximum_Booking_Notice_Min) !== null && _Maximum_Booking_Notice_Min !== void 0 ? _Maximum_Booking_Notice_Min : info.Maximum_Booking_Notice_Min) !== null && ref !== void 0 ? ref : 0;
                            if (maximum === 0) return (0,date_fns_tz.formatInTimeZone)((0,addMonths/* default */.Z)((0,parseISO/* default */.Z)(range.start), 6), timeZone, "yyyy-MM-dd HH:00:ssXXX");
                            var dte = (0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd HH:00:ssXXX"));
                            if ((0,isSameDay/* default */.Z)((0,parseISO/* default */.Z)(range.start), dte)) return (0,date_fns_tz.formatInTimeZone)((0,addMinutes/* default */.Z)(dte, maximum), timeZone, "yyyy-MM-dd HH:00:ssXXX");
                            else return (0,date_fns_tz.formatInTimeZone)((0,addMinutes/* default */.Z)((0,parseISO/* default */.Z)(range.start), maximum), timeZone, "yyyy-MM-dd HH:00:ssXXX");
                        };
                        generatePayload = function(dpc) {
                            var start = getStartDate(source[0]);
                            var end = isOverSeven((0,parseISO/* default */.Z)(getEndDate(source[0])), (0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd 23:59:ssXXX"))) ? (0,date_fns_tz.formatInTimeZone)(range.end, timeZone, "yyyy-MM-dd 23:59:ssXXX") : (0,date_fns_tz.formatInTimeZone)(getEndDate(source[0]), timeZone, "yyyy-MM-dd 23:59:ssXXX");
                            var ref;
                            var payload = {
                                staff: [
                                    {
                                        id: dpc === null || dpc === void 0 ? void 0 : dpc.staff_id,
                                        blockedDays: (ref = dpc === null || dpc === void 0 ? void 0 : dpc.blockedDays) !== null && ref !== void 0 ? ref : [],
                                        email: dpc === null || dpc === void 0 ? void 0 : dpc.staff_email
                                    }, 
                                ],
                                interval: info.Duration_Min,
                                buffer: info.Buffer_Time_Min,
                                startDate: start,
                                timeZone: timeZone,
                                endDate: end
                            };
                            return payload;
                        };
                        shuffle = function(array) {
                            for(var i = array.length - 1; i > 0; i--){
                                var j = Math.floor(Math.random() * (i + 1));
                                var ref;
                                ref = [
                                    array[j],
                                    array[i]
                                ], array[i] = ref[0], array[j] = ref[1], ref;
                            }
                            return array;
                        };
                        source = useAll ? shuffle(staff) : [
                            dpc
                        ];
                        data = [];
                        setLoading(true);
                        _ctx.next = 14;
                        return Promise.all(source.map(function(p) {
                            return fetcher("".concat("https://api-auth.thrivelab.com/api", "/calendar"), generatePayload(p), controller);
                        }));
                    case 14:
                        allResults = _ctx.sent;
                        allResults.forEach(function(result) {
                            var _data;
                            (_data = data).push.apply(_data, (0,_to_consumable_array/* default */.Z)(result));
                        });
                        setLoading(false);
                        setSelectedDay((0,date_fns_tz.formatInTimeZone)(range.start, timeZone, "yyyy-MM-dd"));
                        filtered = data.filter(function(d) {
                            return (0,date_fns_tz.formatInTimeZone)(d.date, timeZone, "yyyy-MM-dd") <= (0,date_fns_tz.formatInTimeZone)(range.end, timeZone, "yyyy-MM-dd");
                        });
                        setRawSlots(filtered !== null && filtered !== void 0 ? filtered : []);
                        _ctx.next = 27;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(axios_default().isCancel(_ctx.t0) || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.code) === "ERR_CANCELED")) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 26:
                        throw _ctx.t0;
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    22
                ]
            ]);
        }));
        return function(controller) {
            return _ref.apply(this, arguments);
        };
    }(), [
        timeZone,
        useAll,
        staff,
        dpc,
        range.retries,
        range.start,
        range.end,
        info
    ]);
    (0,react.useEffect)(function() {
        var controller = new AbortController();
        fetchSlots(controller);
        return function() {
            controller.abort();
        };
    }, [
        fetchSlots
    ]);
    (0,react.useEffect)(function() {
        if ((rawSlots === null || rawSlots === void 0 ? void 0 : rawSlots.length) > 0 && !loading) {
            var selected = selectedDay !== null && selectedDay !== void 0 ? selectedDay : (0,date_fns_tz.formatInTimeZone)(range.start, timeZone, "yyyy-MM-dd");
            var slotsForTheDay = rawSlots.filter(function(t) {
                return t.date === selected;
            });
            var emptySlots = slotsForTheDay.length === 0;
            if (emptySlots) setSelectedDay(rawSlots[0].date);
            onRangeChanged({
                slot: !emptySlots ? slotsForTheDay : rawSlots,
                isLoading: loading,
                selectedDay: !emptySlots ? selected : rawSlots[0].date
            });
        } else if ((rawSlots === null || rawSlots === void 0 ? void 0 : rawSlots.length) === 0 && !loading && range.retries < 5) {
            setLoading(true);
            var nextEnd = (0,addDays/* default */.Z)((0,parseISO/* default */.Z)(range.end), 7);
            setRange(function(prev) {
                return {
                    start: (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)((0,parseISO/* default */.Z)(range.end), 1), timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
                    end: (0,date_fns_tz.formatInTimeZone)(nextEnd, timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
                    auto: false,
                    retries: prev.retries + 1
                };
            });
        } else if (range.retries === 5) {
            setLoading(false);
            onRangeChanged({
                slot: [],
                isLoading: false,
                selectedDay: ""
            });
        } else {
            onRangeChanged({
                slot: [],
                isLoading: loading,
                selectedDay: ""
            });
        }
    }, [
        loading,
        onRangeChanged,
        range,
        rawSlots,
        selectedDay,
        timeZone,
        info,
        staff, 
    ]);
    var handlePrevious = function() {
        var nextEnd = (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)((0,parseISO/* default */.Z)(range.end), -7), timeZone, "yyyy-MM-dd HH:mm:ssXXX");
        var nextStart = (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)((0,parseISO/* default */.Z)(range.end), -13), timeZone, "yyyy-MM-dd HH:mm:ssXXX");
        var currentDate = (0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd HH:mm:ssXXX"));
        if ((0,parseISO/* default */.Z)(nextStart) < currentDate) {
            nextStart = (0,date_fns_tz.formatInTimeZone)(currentDate, timeZone, "yyyy-MM-dd HH:mm:ssXXX");
            nextEnd = (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)(currentDate, 7), timeZone, "yyyy-MM-dd HH:mm:ssXXX");
        }
        setRawSlots([]);
        setLoading(true);
        setRange({
            start: nextStart,
            end: nextEnd,
            auto: false,
            retries: 0
        });
        onRangeChanged({
            slot: [],
            isLoading: true,
            selectedDay: ""
        });
    };
    var handleNext = function() {
        var nextEnd = (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)((0,parseISO/* default */.Z)(range.end), 7), timeZone, "yyyy-MM-dd HH:mm:ssXXX");
        setRawSlots([]);
        setRange({
            start: (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)((0,parseISO/* default */.Z)(range.end), 1), timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
            end: nextEnd,
            auto: false,
            retries: 0
        });
        setLoading(true);
        onRangeChanged({
            slot: [],
            isLoading: true,
            selectedDay: ""
        });
    };
    var handleMonthChange = function(date) {
        if (!date || !(0,isValid/* default */.Z)(date)) return;
        // onDaySelected('');
        var currentDate = (0,parseISO/* default */.Z)((0,date_fns_tz.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd HH:mm:ssXXX"));
        setRawSlots([]);
        if (date < currentDate) {
            setDisplayDate((0,date_fns_tz.formatInTimeZone)(currentDate, timeZone, "yyyy-MM-dd"));
            setRange({
                start: (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)(currentDate, 3), timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
                end: (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)(currentDate, 7), timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
                auto: false,
                retries: 0
            });
        } else {
            var first = (0,startOfMonth/* default */.Z)(date);
            setDisplayDate((0,date_fns_tz.formatInTimeZone)(first, timeZone, "yyyy-MM-dd HH:mm:ssXXX"));
            setRange({
                start: (0,date_fns_tz.formatInTimeZone)((0,addDays/* default */.Z)(first, -7), timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
                end: (0,date_fns_tz.formatInTimeZone)(first, timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
                auto: false,
                retries: 0
            });
        }
    };
    var handleDateSelected = function(date) {
        setSelectedDay(date);
        setDisplayDate((0,date_fns_tz.formatInTimeZone)(date, timeZone, "yyyy-MM-dd"));
    };
    var disabledNext = function() {
        return maxDate !== null && (0,parseISO/* default */.Z)(maxDate) < (0,addDays/* default */.Z)((0,parseISO/* default */.Z)(range.end), 1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 4,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                    dateAdapter: AdapterDateFns/* AdapterDateFns */.H,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* DatePicker */.M, {
                                views: [
                                    "year",
                                    "month"
                                ],
                                label: selectedDay !== "" ? "Selected Month and Year" : "",
                                minDate: new Date(new build/* DateObject */.NT().toFirstOfMonth().format()),
                                maxDate: maxDate ? (0,parseISO/* default */.Z)(maxDate) : (0,addYears/* default */.Z)(new Date(), 1),
                                value: displayDate ? (0,parseISO/* default */.Z)(displayDate) : selectedDay,
                                onChange: handleMonthChange,
                                open: open,
                                onOpen: function() {
                                    return setOpen(true);
                                },
                                onClose: function() {
                                    return setOpen(false);
                                },
                                renderInput: function(params) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        sx: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarTextField, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                                ref: params.inputRef,
                                                helperText: null,
                                                size: "small",
                                                fullWidth: false,
                                                sx: {
                                                    "& .MuiOutlinedInput-input": {
                                                        fontFamily: "ABCDiaTypeRegular",
                                                        width: {
                                                            xs: "100%",
                                                            sm: "60%"
                                                        },
                                                        fontSize: "20px"
                                                    }
                                                },
                                                variant: "outlined"
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                onClick: function() {
                                                    return setOpen(true);
                                                },
                                                sx: {
                                                    m: 0,
                                                    p: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* default */.Z, {
                                                    icon: "ant-design:caret-down-filled",
                                                    color: "primary",
                                                    width: 24,
                                                    height: 24,
                                                    sx: {
                                                        display: {
                                                            xs: "block",
                                                            sm: "none"
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                sx: {
                                    fontFamily: "ABCDiaTypeRegular",
                                    textTransform: "none",
                                    textDecoration: "underline",
                                    fontSize: "16px",
                                    width: "70%"
                                },
                                onClick: function() {
                                    return setOpen(true);
                                },
                                children: "See More"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(services_range, {
                    range: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, range), {
                        isLoading: loading
                    }),
                    rawSlots: rawSlots,
                    selectedDay: selectedDay,
                    handleDateSelected: handleDateSelected,
                    timeZone: timeZone,
                    maxDate: maxDate,
                    minimum: determinMin(info, staff),
                    serviceId: serviceId
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: "97%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    my: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handlePrevious,
                        disabled: new Date(range.start) < (0,addDays/* default */.Z)(new Date(), 1),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* default */.Z, {
                            icon: "akar-icons:chevron-left",
                            color: "primary"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleNext,
                        disabled: disabledNext(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* default */.Z, {
                            icon: "akar-icons:chevron-right",
                            color: "primary"
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            align: "center",
                            variant: "caption",
                            component: "div",
                            color: "primary",
                            children: "Please wait..."
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var rangeSelector = (RangeSelector);

;// CONCATENATED MODULE: ./components/services/schedulePicker.tsx




// =======================================================
var SchedulePicker = function(param) {
    var dpc = param.dpc, onChange = param.onChange, timeZone = param.timeZone, useAll = param.useAll, staff = param.staff, info = param.info, state = param.state;
    var ref = (0,react.useState)(new Date()), startDate = ref[0], setStartDate = ref[1];
    var handleRange = (0,react.useCallback)(function(param) {
        if (param.selectedDay !== "") {
            setStartDate(param.selectedDay !== "" ? new Date(param.selectedDay) : new Date());
        }
        onChange(param.slot, param.isLoading, param.selectedDay);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                my: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h5",
                    color: "primary",
                    sx: {
                        fontFamily: "JazminAlt",
                        fontSize: "30px",
                        textAlign: "center"
                    },
                    children: [
                        info.service_name ? "".concat(info.service_name, " - ") : "",
                        " ",
                        state && state !== "" ? "(".concat(state, ")") : "",
                        " Pick a day and time that works for you"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    variant: "standard",
                    color: "info",
                    children: "Please allow up to 30 seconds while we search our calendars for the next available appointment. Thank you for your patience."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(rangeSelector, {
                    useAll: useAll,
                    staff: staff,
                    onRangeChanged: handleRange,
                    timeZone: timeZone,
                    dpc: dpc,
                    info: info,
                    startDate: startDate,
                    serviceId: staff[0].service_id
                })
            ]
        })
    });
};
/* harmony default export */ var schedulePicker = (SchedulePicker);


/***/ }),

/***/ 7746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51233);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25662);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76295);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50135);






var Staff = function(param) {
    var dpc = param.dpc, dpcs = param.dpcs, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), staff = ref[0], setStaff = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showStaff = ref1[0], setShowStaff = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setStaff(dpc);
    }, [
        dpc
    ]);
    var handleSelectDpc = function(value) {
        onChange(value);
        setStaff(value);
        setShowStaff(false);
    };
    var defaultProps = {
        options: dpcs,
        getOptionLabel: function(option) {
            return option.staff_name;
        }
    };
    var handleShowStaffList = function() {
        setShowStaff(!showStaff);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                sx: {
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            "Your appointment will be booked with",
                            " ",
                            (staff === null || staff === void 0 ? void 0 : staff.staff_name) ? "".concat(staff.staff_name) : "any available staff"
                        ]
                    }),
                    dpcs && dpcs.length > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        onClick: handleShowStaffList,
                        sx: {
                            textTransform: "none",
                            fontFamily: "Arial",
                            fontSize: "18px"
                        },
                        children: "Change"
                    }) : null
                ]
            }),
            showStaff && /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, defaultProps), {
                key: Date.now(),
                size: "small",
                onChange: function(_, newValue) {
                    handleSelectDpc(newValue);
                },
                defaultValue: dpcs.find(function(x) {
                    return x.staff_id === (staff === null || staff === void 0 ? void 0 : staff.staff_id);
                }) ? staff : null,
                renderInput: function(params) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, params), {
                        label: "Choose a Staff",
                        inputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, params.inputProps), {
                            autoComplete: "new-password",
                            type: "search"
                        })
                    }));
                }
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Staff);


/***/ }),

/***/ 63722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70722);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(date_fns_tz__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76295);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50135);
/* harmony import */ var _utils_calendarHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96484);








var TimeZones = function(param) {
    var defaultTimeZone = param.defaultTimeZone, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultTimeZone), timeZone = ref[0], setTimeZone = ref[1];
    var timeZones = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_calendarHelper__WEBPACK_IMPORTED_MODULE_2__/* .getUsedTzs */ .qZ)();
    }, []);
    var handleSelectTimezone = function(value) {
        setTimeZone(value);
        onChange(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        size: "small",
        options: timeZones,
        getOptionLabel: function(option) {
            return "".concat(option.name, " Time - ").concat((0,date_fns_tz__WEBPACK_IMPORTED_MODULE_4__.formatInTimeZone)(new Date(), option.name, "p"));
        },
        fullWidth: true,
        defaultValue: timeZone,
        onChange: function(_, newValue) {
            handleSelectTimezone(newValue);
        },
        disableClearable: true,
        isOptionEqualToValue: function(t) {
            return t.name === timeZone.name;
        },
        renderOption: function(props, option) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                component: "li"
            }, props), {
                key: option.name,
                sx: {
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    flexDirection: "row",
                    gap: 1,
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            width: "80%"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "body2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                style: {
                                    fontFamily: "ABCDiaTypebold"
                                },
                                children: [
                                    option.name,
                                    " Time"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        variant: "body2",
                        sx: {
                            justifySelf: "flex-end",
                            width: "20%",
                            textAlign: "right"
                        },
                        children: (0,date_fns_tz__WEBPACK_IMPORTED_MODULE_4__.formatInTimeZone)(new Date(), option.name, "p")
                    })
                ]
            }));
        },
        renderInput: function(params) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                label: "Choose a Timezone",
                inputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params.inputProps), {
                    autoComplete: "new-password",
                    type: "search"
                })
            }));
        }
    }, Date.now());
};
/* harmony default export */ __webpack_exports__["Z"] = (TimeZones);


/***/ }),

/***/ 62106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AX": function() { return /* binding */ cancelFreeConsult; },
/* harmony export */   "Jt": function() { return /* binding */ bookFreeConsult; },
/* harmony export */   "Ke": function() { return /* binding */ updateFreeConsult; },
/* harmony export */   "Pp": function() { return /* binding */ getFreeConsult; },
/* harmony export */   "Qo": function() { return /* binding */ useBookingContext; }
/* harmony export */ });
/* unused harmony exports checkMeeting, cancelBooking */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42309);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58545);
/* harmony import */ var _contexts_HVBContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58995);









// ==========================================================================================
var useBookingContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_HVBContext__WEBPACK_IMPORTED_MODULE_4__/* .BookingContext */ .z);
};
var bookFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var ref, payload, result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                        utmCode: {
                            utm_campaign: params.utm_campaign,
                            utm_content: params.utm_content,
                            utm_medium: params.utm_medium,
                            utm_source: params.utm_source,
                            utm_term: params.utm_term
                        }
                    });
                    _ctx.next = 4;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat("https://api-auth.thrivelab.com/api", "/staff/book"), payload);
                case 4:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        // isError:
                        //   data?.zoho?.toLowerCase() !== "success!" ||
                        //   !data?.calId ||
                        //   status !== 201,
                        isError: (data === null || data === void 0 ? void 0 : data.zoho) && (data === null || data === void 0 ? void 0 : (ref = data.zoho) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || status !== 201
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function bookFreeConsult(params) {
        return _ref.apply(this, arguments);
    };
}();
var canCancelOrSched = function(data) {
    var ref = data !== null && data !== void 0 ? data : {
        Cancelation_and_Rescheduling_Window_Min: null,
        Start_DateTime: null
    }, cancelWindow = ref.Cancelation_and_Rescheduling_Window_Min, Start_DateTime = ref.Start_DateTime;
    if (!Start_DateTime) return true;
    var allowedDate = Start_DateTime ? (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Start_DateTime) : null;
    if (cancelWindow && Start_DateTime) {
        allowedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Start_DateTime), -Number(cancelWindow));
    }
    if (!(data === null || data === void 0 ? void 0 : data.Cancelation_and_Rescheduling_Window_Min)) return true;
    else if (allowedDate) return new Date() < allowedDate;
    else return true;
};
var getFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat("https://api-auth.thrivelab.com/api", "/calendar/").concat(id));
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data), {
                            canCancelOrResched: canCancelOrSched(data)
                        }),
                        isLoading: false,
                        status: status,
                        isError: status !== 200
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFreeConsult(id) {
        return _ref.apply(this, arguments);
    };
}();
var updateFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var payload, result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                        utmCode: {
                            utm_campaign: params.utm_campaign,
                            utm_content: params.utm_content,
                            utm_medium: params.utm_medium,
                            utm_source: params.utm_source,
                            utm_term: params.utm_term
                        }
                    });
                    _ctx.next = 3;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].put */ .Z.put("".concat("https://api-auth.thrivelab.com/api", "/staff/book"), payload);
                case 3:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", {
                        data: data,
                        status: status,
                        isLoading: false,
                        isError: data === null || status !== 200
                    });
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateFreeConsult(params) {
        return _ref.apply(this, arguments);
    };
}();
var cancelFreeConsult = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _utils_axios_util__WEBPACK_IMPORTED_MODULE_2__/* ["default"].put */ .Z.put("".concat("https://api-auth.thrivelab.com/api", "/staff/cancel"), params);
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 200 || data === ""
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cancelFreeConsult(params) {
        return _ref.apply(this, arguments);
    };
}();
var checkMeeting = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_3___default().get("/api/check-booking/?email=".concat(email));
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkMeeting(email) {
        return _ref.apply(this, arguments);
    };
}();
var cancelBooking = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bookingId) {
        var result, data, status;
        return _codebuild_output_src3969599579_src_ocw_booking_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_3___default().post("/api/cancel-booking", {
                        booking_id: bookingId
                    });
                case 2:
                    result = _ctx.sent;
                    data = result.data, status = result.status;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data || {}), {
                        status: status,
                        isLoading: false,
                        isError: status !== 200
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cancelBooking(bookingId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cj": function() { return /* binding */ getDefaultTz; },
/* harmony export */   "qZ": function() { return /* binding */ getUsedTzs; }
/* harmony export */ });
/* unused harmony export getWeeksInMonth */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _vvo_tzdb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94759);



var getWeeksInMonth = function(year, month) {
    var weeks = [], firstDate = new Date(year, month, 1), lastDate = new Date(year, month + 1, 0), numDays = lastDate.getDate();
    var dayOfWeekCounter = firstDate.getDay();
    for(var date = 1; date <= numDays; date++){
        if (dayOfWeekCounter === 0 || weeks.length === 0) {
            weeks.push([]);
        }
        weeks[weeks.length - 1].push(date);
        dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
    }
    return weeks.filter(function(w) {
        return !!w.length;
    }).map(function(w) {
        return {
            start: w[0],
            end: w[w.length - 1],
            dates: w
        };
    });
};
var USED_TZS = [
    "US/Hawaii",
    "US/Alaska",
    "US/Pacific",
    "US/Mountain",
    "US/Central",
    "US/Eastern",
    "US/Arizona", 
];
var getUsedTzs = function() {
    var usedTzs = _vvo_tzdb__WEBPACK_IMPORTED_MODULE_0__.filter(function(tz) {
        return tz.group.find(function(g) {
            return USED_TZS.includes(g);
        });
    });
    var ref;
    var remapped = usedTzs.map(function(tz) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, tz), {
            name: (ref = USED_TZS.find(function(t) {
                return tz.group.includes(t);
            })) !== null && ref !== void 0 ? ref : tz.name
        });
    });
    return remapped;
};
var getDefaultTz = function(tz) {
    var selected = _vvo_tzdb__WEBPACK_IMPORTED_MODULE_0__.find(function(t) {
        return t.group.includes(tz);
    });
    var tzs = getUsedTzs();
    var ref;
    var defaultTz = (ref = tzs.find(function(t) {
        return (selected === null || selected === void 0 ? void 0 : selected.name.includes("America/Phoenix")) ? t.name === "US/Arizona" : t.alternativeName === (selected === null || selected === void 0 ? void 0 : selected.alternativeName);
    })) !== null && ref !== void 0 ? ref : tzs[0];
    return defaultTz;
};


/***/ }),

/***/ 88303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ includeSlotsWith; },
/* harmony export */   "v": function() { return /* binding */ groupByDayTime; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70722);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(date_fns_tz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28401);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58545);



function groupByDayTime(slots, timeZone, minimum, serviceId, info) {
    var available = [];
    slots.forEach(function(slot) {
        var _available;
        var items = slot.available.map(function(time) {
            return {
                timeZone: timeZone !== null && timeZone !== void 0 ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone,
                date: slot.date,
                id: slot.id,
                orgTime: time,
                time: (0,date_fns_tz__WEBPACK_IMPORTED_MODULE_0__.formatInTimeZone)(time, timeZone !== null && timeZone !== void 0 ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone, "p"),
                staffId: slot.staffId,
                staffEmail: slot.staffEmail,
                hour: Number((0,date_fns_tz__WEBPACK_IMPORTED_MODULE_0__.formatInTimeZone)(time, timeZone !== null && timeZone !== void 0 ? timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone, "HH"))
            };
        });
        (_available = available).push.apply(_available, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(items));
    });
    available = available.sort(function(a, b) {
        return a.hour - b.hour;
    }).filter(function(t) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(t.orgTime)) > (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,date_fns_tz__WEBPACK_IMPORTED_MODULE_0__.formatInTimeZone)(new Date(), timeZone, "yyyy-MM-dd HH:mm:ssXXX")), minimum !== null && minimum !== void 0 ? minimum : 0));
    });
    var morning = (available === null || available === void 0 ? void 0 : available.filter(function(t) {
        return t.hour < 12;
    })) || [];
    var afternoon = (available === null || available === void 0 ? void 0 : available.filter(function(t) {
        return t.hour >= 12 && t.hour < 18;
    })) || [];
    var evening = (available === null || available === void 0 ? void 0 : available.filter(function(t) {
        return t.hour >= 18;
    })) || [];
    if (serviceId) {
        morning = includeSlotsWith(morning, info);
        afternoon = includeSlotsWith(afternoon, info);
        evening = includeSlotsWith(evening, info);
    }
    var data = morning.concat(afternoon).concat(evening);
    return {
        morning: morning,
        afternoon: afternoon,
        evening: evening,
        isEmpty: data.length === 0
    };
}
var includeSlotsWith = function(source, info) {
    var ref;
    var serviceSetting = info === null || info === void 0 ? void 0 : (ref = info.includedMins) === null || ref === void 0 ? void 0 : ref.map(function(s) {
        return s.length === 1 ? "0".concat(s) : s;
    });
    if (!serviceSetting) return source;
    var result = source.filter(function(slot) {
        return serviceSetting.includes((0,date_fns_tz__WEBPACK_IMPORTED_MODULE_0__.formatInTimeZone)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(slot.orgTime), slot.timeZone, "mm"));
    });
    return result;
};


/***/ }),

/***/ 38659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getTrackers; }
/* harmony export */ });
/* unused harmony export parseCampaign */
var parseCampaign = function(campaign, referrer) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var raw = decodeURIComponent(campaign);
    var qs = ((ref = raw.split("?")) === null || ref === void 0 ? void 0 : ref[1]) || "";
    var utms = qs.split("&") || [];
    var utm_source = ((ref1 = utms.find(function(f) {
        return f.includes("utm_source=");
    })) === null || ref1 === void 0 ? void 0 : ref1.replace("utm_source=", "")) || "";
    var utm_medium = ((ref2 = utms.find(function(f) {
        return f.includes("utm_medium=");
    })) === null || ref2 === void 0 ? void 0 : ref2.replace("utm_medium=", "")) || "";
    var utm_campaign = ((ref3 = utms.find(function(f) {
        return f.includes("utm_campaign=");
    })) === null || ref3 === void 0 ? void 0 : ref3.replace("utm_campaign=", "")) || "";
    var utm_content = ((ref4 = utms.find(function(f) {
        return f.includes("utm_content=");
    })) === null || ref4 === void 0 ? void 0 : ref4.replace("utm_content=", "")) || "";
    var utm_term = ((ref5 = utms.find(function(f) {
        return f.includes("utm_term=");
    })) === null || ref5 === void 0 ? void 0 : ref5.replace("utm_term=", "")) || "";
    return {
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        utm_content: utm_content,
        utm_term: utm_term,
        gtm_referrer: referrer,
        gtm_campaign_url: campaign
    };
};
var getTrackers = function(cookies, query) {
    var ref, ref1, ref2, ref3, ref4;
    var _utm_source = query.utm_source, utm_source = _utm_source === void 0 ? "" : _utm_source, _utm_medium = query.utm_medium, utm_medium = _utm_medium === void 0 ? "" : _utm_medium, _utm_campaign = query.utm_campaign, utm_campaign = _utm_campaign === void 0 ? "" : _utm_campaign, _utm_content = query.utm_content, utm_content = _utm_content === void 0 ? "" : _utm_content, _utm_term = query.utm_term, utm_term = _utm_term === void 0 ? "" : _utm_term, _type = query.type, type = _type === void 0 ? "" : _type, _payor = query.payor, payor = _payor === void 0 ? "" : _payor, __ef_transaction_id = query._ef_transaction_id, _ef_transaction_id = __ef_transaction_id === void 0 ? "" : __ef_transaction_id, _flow_type = query.flow_type, flow_type = _flow_type === void 0 ? "" : _flow_type;
    var cookie = parseCampaign((ref = cookies[0]) === null || ref === void 0 ? void 0 : ref.__gtm_campaign_url, (ref1 = cookies[0]) === null || ref1 === void 0 ? void 0 : ref1.__gtm_referrer);
    return {
        Source: utm_source !== "" ? utm_source : cookie.utm_source ? cookie.utm_source : (ref2 = cookies[0]) === null || ref2 === void 0 ? void 0 : ref2.og_referrer_domain,
        utm_source: utm_source !== "" ? utm_source : cookie.utm_source,
        utm_medium: utm_medium !== "" ? utm_medium : cookie.utm_medium,
        utm_campaign: utm_campaign !== "" ? utm_campaign : cookie.utm_campaign,
        utm_content: utm_content !== "" ? utm_content : cookie.utm_content,
        utm_term: utm_term !== "" ? utm_term : cookie.utm_term,
        gtm_referrer: cookie.gtm_referrer || "",
        gtm_campaign_url: cookie.gtm_campaign_url || "",
        entryPoint: window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : ref3.href,
        og_referrer: (ref4 = cookies[0]) === null || ref4 === void 0 ? void 0 : ref4.og_referrer_domain,
        type: type,
        insurance: payor.toString(),
        _ef_transaction_id: _ef_transaction_id.toString(),
        flow_type: flow_type.toString()
    };
};


/***/ }),

/***/ 214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","main":"Home_main__nLjiQ","success":"Home_success__cqYiE","grid":"Home_grid__GxQ85","card":"Home_card___LpL1","footer":"Home_footer____T7K","code":"Home_code__suPER","logo":"Home_logo__27_tb"};

/***/ })

}]);